import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import LandingPage from './pages/LandingPage';
import AdminPanel from './components/AdminPanel';
import './App.css';

function CursorGlow() {
  useEffect(() => {
    const glow = document.createElement('div');
    glow.className = 'cursor-glow';
    document.body.appendChild(glow);
    const move = (e) => {
      glow.style.left = e.clientX + 'px';
      glow.style.top = e.clientY + 'px';
    };
    window.addEventListener('mousemove', move);
    return () => {
      window.removeEventListener('mousemove', move);
      if (document.body.contains(glow)) document.body.removeChild(glow);
    };
  }, []);
  return null;
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        {/* Full-page animated dark background */}
        <div className="page-animated-bg" />
        {/* Scanlines overlay */}
        <div className="scanlines fixed inset-0 z-[1] pointer-events-none opacity-100" />
        <CursorGlow />
        <div className="relative z-[2]">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}
